import React, { useState, useEffect, useContext } from "react";


import { AuthContext } from "../../contexts/auth";
import { AiOutlineClose } from "react-icons/ai";
import {
  IoLocationOutline,
  IoDocumentAttachSharp,
  IoTrash,
} from "react-icons/io5";

import ReactLoading from "react-loading";
import { toast } from "react-toastify";
import config from "../../config";

export default function ModalUpdateIngressoAvulso({
  closeModal,
  _dataLocacao,
  vendedores,
  id_event,
  id_map,
  updateLocalIngressos,
  openModalDeleteIngresso,
}) {
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [dataLocacao, setDataLocacao] = useState(null);
  const [formData, setFormData] = useState({
    id_event,
    id_map,
    id_ingresso: _dataLocacao?._id,

    status: "",
    comprador: "",
    vendedor: "",
    vendedor_nome: "",

    lugares: [],
    qtd_lugares: 0,

    valor_total_locacao: 0,
    valor_recebido: 0,

    anotacoes_financeiras: "",
    formas_de_pagamento: [],
  });

  /* ======================================================
     BUSCA DOS DADOS
  ====================================================== */
  useEffect(() => {
    if (_dataLocacao?._id) getDataIngresso(_dataLocacao._id);
  }, [_dataLocacao?._id]);

  const getDataIngresso = async (id_ingresso) => {
    try {
      setLoading(true);
      console.log({
        email: user.email,
        token: user.token,
        id_map,
        id_ingresso,
      });
      const res = await fetch(`${config.urlServer}/event/get-data-ingresso`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: user.email,
          token: user.token,
          id_map,
          id_ingresso,
        }),
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json.msg || "Erro ao buscar ingresso");

      setDataLocacao(json.ingresso);
    } catch (err) {
      toast.error(err.message);
      closeModal();
    } finally {
      setLoading(false);
    }
  };

  /* ======================================================
     HIDRATAÇÃO DO FORMULÁRIO
  ====================================================== */
  useEffect(() => {
    if (!dataLocacao) return;

    setFormData({
      id_event,
      id_map,
      id_ingresso: dataLocacao._id,

      status: dataLocacao.status || "disponivel",
      comprador: dataLocacao.comprador || "",

      vendedor: dataLocacao.vendedor || "",
      vendedor_nome: dataLocacao.vendedor_nome || "",

      lugares: dataLocacao.lugares || [],
      qtd_lugares: dataLocacao.lugares?.length || 0,

      valor_total_locacao: dataLocacao.valor_total_locacao || 0,
      valor_recebido: dataLocacao.valor_recebido || 0,

      anotacoes_financeiras: dataLocacao.anotacoes_financeiras || "",

      formas_de_pagamento: dataLocacao.formas_de_pagamento || [],
    });
  }, [dataLocacao]);

  /* ======================================================
     FINANCEIRO
  ====================================================== */
  const recalcValorRecebido = (formas) => {
    const total = formas.reduce((sum, f) => sum + Number(f.valor || 0), 0);

    setFormData((prev) => ({
      ...prev,
      formas_de_pagamento: formas,
      valor_recebido: total,
    }));
  };

  const addFormaPagamento = () => {
    recalcValorRecebido([
      ...formData.formas_de_pagamento,
      {
        tipo: "",
        valor: 0,
        data_pagamento: new Date().toISOString().split("T")[0],
        observacao: "",
      },
    ]);
  };

  const updateFormaPagamento = (i, field, value) => {
    const clone = [...formData.formas_de_pagamento];
    clone[i][field] = value;
    recalcValorRecebido(clone);
  };

  const removeFormaPagamento = (i) => {
    const clone = [...formData.formas_de_pagamento];
    clone.splice(i, 1);
    recalcValorRecebido(clone);
  };

  /* ======================================================
     SALVAR
  ====================================================== */
  const updateIngresso = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${config.urlServer}/event/update-ingresso-completo`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: user.email,
            token: user.token,
            data: { ...formData },
          }),
        }
      );

      const json = await res.json();
      if (!res.ok) throw new Error(json.error || "Erro ao atualizar ingresso");

      toast.success("Ingresso atualizado com sucesso!");

      // 🔥 ATUALIZA ESTADO GLOBAL
      updateLocalIngressos(json.ingresso_atualizado);

      // 🔥 ATUALIZA O MODAL (evita inconsistência visual)
      setDataLocacao(json.ingresso_atualizado);

      closeModal();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  /* ======================================================
     RENDER
  ====================================================== */
  if (loading)
    return (
      <div className="flex justify-center items-center h-64">
        <ReactLoading type="spinningBubbles" color="#ca8a04" />
      </div>
    );

  return (
    <div className="bg-white rounded-lg shadow-lg w-full max-w-[100vw] h-full overflow-hidden relative border border-gray-300 flex flex-col">
      {/* ================= HEADER FIXO ================= */}
      <div className="sticky top-0 border-b border-gray-400 p-2">
        <header className="bg-white flex justify-between items-center px-8 py-4 shadow-sm">
          <div className="flex items-center gap-2">
            <IoLocationOutline className="text-gray-700" size={22} />
            <h2 className="text-lg font-semibold">
              Ingresso nº{" "}
              <span className="text-emerald-700">{dataLocacao?.numero}</span>
            </h2>
          </div>
          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-red-600"
          >
            <AiOutlineClose size={24} />
          </button>
        </header>

        {/* STATUS */}
        <div className="flex gap-2 px-8 pb-2">
          {["disponivel", "reservado", "vendido"].map((s) => {
            const bgColor =
              s === "vendido"
                ? "var(--grass)"
                : s === "reservado"
                ? "var(--rotary-gold)"
                : "var(--cardinal)";

            return (
              <button
                key={s}
                type="button"
                onClick={() => setFormData((prev) => ({ ...prev, status: s }))}
                style={{
                  backgroundColor:
                    formData.status === s ? bgColor : "transparent",
                  color: formData.status === s ? "#fff" : "#000",
                  borderColor: formData.status === s ? bgColor : "#ccc",
                }}
                className="flex-1 py-1 rounded-md border font-medium transition-all hover:bg-gray-100"
              >
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            );
          })}
        </div>
      </div>

      {/* ================= CONTEÚDO ================= */}
<div className="flex-1 overflow-y-auto px-8 py-4 space-y-6 pb-32">
        {/* VENDEDOR / COMPRADOR */}
        <div className="grid grid-cols-2 gap-4">
          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Vendedor</span>
            <select
              value={formData.vendedor}
              onChange={(e) => {
                const v = vendedores.find((x) => x.email === e.target.value);
                setFormData({
                  ...formData,
                  vendedor: v?.email || "",
                  vendedor_nome: v?.nome || "",
                });
              }}
              className="border border-gray-400 rounded p-2"
            >
              <option value="">Selecione...</option>
              {vendedores.map((v) => (
                <option key={v.email} value={v.email}>
                  {v.nome}
                </option>
              ))}
            </select>
          </label>

          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Comprador</span>
            <input
              type="text"
              value={formData.comprador}
              onChange={(e) =>
                setFormData({ ...formData, comprador: e.target.value })
              }
              className="border border-gray-400 rounded p-2"
              placeholder="Nome do comprador"
            />
          </label>
        </div>

        {/* FORMAS DE PAGAMENTO */}
        <div className="flex flex-col border border-gray-400 rounded p-4 bg-gray-50">
          <div className="flex w-full justify-between items-center mb-2">
            <span className="font-medium text-sm">Formas de pagamento</span>
            <button
              type="button"
              onClick={addFormaPagamento}
              className="text-xs bg-emerald-600 text-white px-3 py-1 rounded hover:bg-emerald-700"
            >
              + Adicionar
            </button>
          </div>

          {formData.formas_de_pagamento.map((fp, i) => (
            <div
              key={i}
              className="grid grid-cols-7 gap-2 mb-2 text-xs items-center border border-gray-300 rounded p-2 bg-white"
            >
              <select
                value={fp.tipo}
                onChange={(e) =>
                  updateFormaPagamento(i, "tipo", e.target.value)
                }
                className="border border-gray-400 rounded p-1 "
              >
                <option value="">Tipo</option>
                <option value="dinheiro">Dinheiro</option>
                <option value="pix">Pix</option>
                <option value="cheque">Cheque</option>
                <option value="outro">Outro</option>
              </select>

              <input
                type="number"
                value={fp.valor}
                onChange={(e) =>
                  updateFormaPagamento(i, "valor", e.target.value)
                }
                className="border border-gray-400 rounded p-1"
                placeholder="Valor"
              />

              <input
                type="date"
                value={fp.data_pagamento}
                onChange={(e) =>
                  updateFormaPagamento(i, "data_pagamento", e.target.value)
                }
                className="border border-gray-400 rounded p-1"
              />

              <input
                type="text"
                value={fp.observacao || ""}
                onChange={(e) =>
                  updateFormaPagamento(i, "observacao", e.target.value)
                }
                className="border border-gray-400 rounded p-1 col-span-2"
                placeholder="Observação"
              />
              <div className="flex items-center gap-4">
                <input
                  type="file"
                  accept="image/*,.pdf"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const fp = formData.formas_de_pagamento[i];
                    const formDataFile = new FormData();
                    formDataFile.append("file", file);
                    formDataFile.append("id_map", id_map);
                    formDataFile.append("id_ingresso", formData.id_ingresso);
                    formDataFile.append("tipo", fp.tipo || "outro");
                    formDataFile.append("valor", fp.valor || 0);
                    formDataFile.append(
                      "data_pagamento",
                      fp.data_pagamento || new Date().toISOString()
                    );
                    formDataFile.append("observacao", fp.observacao || "");

                    try {
                      const res = await fetch(
                        `${config.urlServer}/event/upload-comprovante-ingresso`,
                        {
                          method: "POST",
                          headers: {
                            Authorization: `Bearer ${user.token}`,
                          },
                          body: formDataFile,
                        }
                      );

                      const data = await res.json();

                      if (!res.ok)
                        throw new Error(data.error || "Falha no upload");

                      const updated = [...formData.formas_de_pagamento];
                      updated[i].comprovante_url = data.comprovante_url;

                      setFormData({
                        ...formData,
                        formas_de_pagamento: updated,
                        valor_recebido: updated.reduce(
                          (s, f) => s + parseFloat(f.valor || 0),
                          0
                        ),
                      });

                      toast.success("Pagamento registrado com sucesso!");
                    } catch (error) {
                      console.error(error);
                      toast.error(
                        "Erro ao enviar o comprovante e registrar o pagamento."
                      );
                    }
                  }}
                  className="border border-gray-400 rounded p-1"
                />

                {fp.comprovante_url_virtual ? (
                  <a
                    href={fp.comprovante_url_virtual}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline text-center"
                  >
                    <IoDocumentAttachSharp size={20} />
                  </a>
                ) : (
                  <a
                    // href={fp.comprovante_url_virtual}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 underline text-center hover:cursor-not-allowed"
                  >
                    <IoDocumentAttachSharp size={20} />
                  </a>
                )}

                <button
                  type="button"
                  onClick={async () => {
                    if (!fp._id) return;
                    const confirma = window.confirm(
                      "Tem certeza que deseja deletar este recebimento?"
                    );
                    if (!confirma) return;
                    try {
                      const res = await fetch(
                        `${config.urlServer}/event/delete-comprovante-ingresso`,
                        {
                          method: "POST",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            email: user.email,
                            token: user.token,
                          },
                          body: JSON.stringify({
                            id_map,
                            id_ingresso: formData.id_ingresso,
                            id_forma_pagamento: fp._id,
                          }),
                        }
                      );
                      const data = await res.json();
                      if (!res.ok) throw new Error(data.error);
                      toast.success("Pagamento removido com sucesso!");
                      setFormData((prev) => ({
                        ...prev,
                        formas_de_pagamento: prev.formas_de_pagamento.filter(
                          (f) => f._id !== fp._id
                        ),
                        valor_recebido: prev.formas_de_pagamento
                          .filter((f) => f._id !== fp._id)
                          .reduce((s, f) => s + parseFloat(f.valor || 0), 0),
                      }));
                    } catch (err) {
                      toast.error("Erro ao remover comprovante.");
                    }
                  }}
                  className="text-white rounded p-2 w-[30px]"
                >
                  <IoTrash size={20} className="text-red-600" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* VALORES */}
        <div className="grid grid-cols-2 gap-4">
          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Valor total</span>
            <input
              type="number"
              value={formData.valor_total_locacao}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  valor_total_locacao: e.target.value,
                })
              }
              className="border border-gray-400 rounded p-2"
            />
          </label>

          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Valor recebido</span>
            <input
              readOnly
              value={formData.valor_recebido}
              className="border border-gray-400 rounded p-2 bg-gray-100"
            />
          </label>
        </div>

        {/* ANOTAÇÕES */}
        <label className="flex flex-col text-sm">
          <span className="font-medium mb-1">Anotações gerais</span>
          <textarea
            value={formData.anotacoes_financeiras}
            onChange={(e) =>
              setFormData({
                ...formData,
                anotacoes_financeiras: e.target.value,
              })
            }
            className="border border-gray-400 rounded p-2 w-full"
        style={{ border: "1px solid " }}

          />
        </label>
      </div>

      {/* ================= FOOTER FIXO ================= */}
      <footer className="sticky bottom-0 bg-white border-t border-gray-400 px-4 py-3 flex justify-between items-center shadow-inner">
        <button
          type="button"
          onClick={openModalDeleteIngresso}
          className="border border-red-600 text-red-600 px-6 py-2 rounded hover:bg-red-600 hover:text-white transition"
        >
          Deletar ingresso
        </button>

        <button
          type="button"
          onClick={updateIngresso}
          className="bg-emerald-600 text-white px-8 py-2 rounded hover:bg-emerald-700 transition"
        >
          Salvar
        </button>
      </footer>
    </div>
  );
}
